import { User } from "oidc-client-ts";

const redirectKey = "__redirect";

export function onSigninCallback(user: User | undefined) {
  window.history.replaceState({}, document.title, window.location.pathname);

  if (user) {
    const redirect = window.sessionStorage.getItem(redirectKey);

    if (redirect) {
      sessionStorage.removeItem(redirectKey);
      window.location.replace(redirect);
    }
  }
}

export function saveRedirectAfterSignin() {
  const { hash, pathname, search } = window.location;
  window.sessionStorage.setItem(redirectKey, pathname + search + hash);
}
